export enum Scenario {
  Forward = 'forward',
  Return = 'return',
}
